import WorkroomComponent from './workroom.component'
import WorkroomService from './workroom.service'

import TaskExpertFeedbackModule from './task-expert-feedback'
import ActivityStreamModule from './activity-stream'
import WorkroomProjectInfoModule from './workroom-project-info'
import ProjectSubscribeToNotificationsModule from './project-subscribe-to-notifications'
import ProjectUserCardModule from './project-user-card'
import ProjectTeamModule from './project-team'
import ProjectExpertPodsModule from './project-expert-pods'
import ProjectScopeDocModule from './project-scope-doc'
import ProjectReviewActionsModule from './project-review-actions'

import AdditionalTasksModule from './additional-tasks'
import ProjectSubmissionMetaModule from './submission-meta-modal'

import ProjectClaimsSidebarWidgetComponent from './project-claims/sidebar-widget'
import ProjectWebscannerSidebarWidgetModule from './project-webscanner/sidebar-widget'
import ProjectWebscannerScanHistoryModule from './project-webscanner/scan-history'



const WorkroomModule = angular.module('cdbl.workroom', [
  TaskExpertFeedbackModule,
  ActivityStreamModule,
  WorkroomProjectInfoModule,
  ProjectSubscribeToNotificationsModule,
  AdditionalTasksModule,
  ProjectTeamModule,
  ProjectExpertPodsModule,
  ProjectUserCardModule,
  ProjectScopeDocModule,
  ProjectReviewActionsModule,
  ProjectSubmissionMetaModule,
  ProjectClaimsSidebarWidgetComponent,

  ProjectWebscannerSidebarWidgetModule,
  ProjectWebscannerScanHistoryModule,
])
  .service('WorkroomService', WorkroomService)
  .component('cdblWorkroom', WorkroomComponent)
  .name

export default WorkroomModule
